module.exports = __webpack_public_path__ + "static/ibm-plex-sans-latin-d28498895ed7050c37c94ddd026a4670.woff2";